<template>
  <div id="footer">
    
    <div class="footer4">
      <div class="contentWidth">
        <span style="display: flex;align-items: center;justify-content: center; ">
          <span class="privacy-policy" @click="goToPrivacyPolicy">隐私政策</span>
          北京数聚智连科技股份有限公司版权所有 <span style="cursor:pointer;" @click="beian">© 2019京ICP备16050841号</span>
          <a target="_blank" 
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502038844" 
          style="display:inline-block;text-decoration:none;height:20px;line-height:20px;margin-left:40px;display: inline-flex;align-items: center;">
          <img src="../assets/img/gb231.png"/>
          <span style="height:80px;line-height:80px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010502038844号</span >
          </a>
  
        </span>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer1',
  data () {
    return {
    }
  },
  methods:{
    beian(){
      window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index'
    },
    goToPrivacyPolicy() {
      // 方式1：使用路由跳转（推荐，如果您的项目使用了Vue Router）
      // 新窗口打开
      const route = this.$router.resolve({ name: 'PrivacyPolicy' })
      window.open(route.href, '_blank')
      
      // 方式2：如果上面的方式不起作用，可以直接使用路径
      // window.open('/privacy-policy', '_blank')
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
@import '../assets/css/norm.less';
#footer{
  display: block;
  background: #fff;
  
  .footer4{
    display: block;
    width: 100%;
    height: 80px;
    position: relative;
    box-sizing: border-box;
    div{
      text-align: center !important;
    }
  }
  .footer4>div>span{
    font-size: 12px;
    line-height: 80px;
    float: left;
    width: 100%;
    color: #828282;
  }
  
  /* 隐私政策样式优化 - 仅修改文字相关样式 */
  .privacy-policy {
    height: 20px;
    line-height: 20px;
    margin: 0px 40px 0px 5px;
    color: #2c3e50;
    font-weight: 500;
    cursor: pointer;
    display: inline-block;
    border-bottom: 2px solid transparent;
    transition: border-bottom-color 0.2s ease;
    font-size: 12px;
  }
  
  .privacy-policy:hover {
    border-bottom-color: #2c3e50;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue